
import { useCallback } from 'react';
import { HeaderGenerationRequest, HeaderGenerationResult } from './types';
import { useHeaderGenerator } from './use-header-generator';

export const useHeaderGeneration = () => {
  const {
    generateHeader: performHeaderGeneration,
    isProcessing,
    hasError,
    canRetry,
    clearError,
    errorState,
  } = useHeaderGenerator();

  const generateHeader = useCallback(async (
    request: HeaderGenerationRequest
  ): Promise<HeaderGenerationResult> => {
    console.log('[HeaderGeneration] ===== HEADER GENERATION REQUESTED =====');
    console.log('[HeaderGeneration] Request details:', {
      contentLength: request.content?.length || 0,
      hasOriginalPrompt: !!request.originalPrompt,
      hasContext: !!request.context,
    });

    return await performHeaderGeneration(request);
  }, [performHeaderGeneration]);

  const retryHeaderGeneration = useCallback(async (
    request: HeaderGenerationRequest
  ): Promise<HeaderGenerationResult> => {
    console.log('[HeaderGeneration] ===== MANUAL RETRY REQUESTED =====');
    console.log('[HeaderGeneration] Manual retry for header generation');
    
    // Generate header (retry logic is handled internally)
    return await generateHeader(request);
  }, [generateHeader]);

  return {
    generateHeader,
    retryHeaderGeneration,
    isProcessing: (requestId?: string) => isProcessing,
    hasError: (requestId?: string) => hasError(requestId),
    canRetry: (requestId?: string) => canRetry(requestId),
    processingCount: isProcessing ? 1 : 0,
    errorState,
  };
};
